import WeekView from "./WeekView";

export default WeekView;
